import { DateTime } from 'luxon';

export const getHoldingPeriod = (deliveryDate: Date, retentionPeriodDays: number) => {
   const deliveryDateTime = DateTime.fromJSDate(deliveryDate);
   return deliveryDateTime.plus({ days: retentionPeriodDays });
};
